import React from 'react';
import { connect } from 'react-redux'
import { Link } from 'react-router-dom';
import swal from 'sweetalert'
import {
  get_project,
  archive_report,
  clone_report,
} from '../actions/'
import Pagination from './Pagination'
import Clipboard from 'react-clipboard.js';

const mapStateToProps = (state) => {
  return {
    report: state.report.report
  }
}

const mapDispatchToProps = dispatch => {
    return {
      getProject: (id, page) => dispatch ( get_project(id, page) ),
      archiveReport: (report_id, page) => dispatch ( archive_report(report_id, page) ),
      cloneReport: (id, page, name) => dispatch( clone_report(id, page, name) ),
    }
}

class ConnectedProjectOptimizations extends React.Component {
  constructor () {
    super()
    this.state = {
      clickedId: ''
    }
  }

  setCurrent(id) {
    this.setState({clickedId: id})
  }

  resetCurrent() {
    this.setState({clickedId: ''})
  }

  archiveReport(report_id) {
    this.setState({clickedId: ''})
    const {page} = this.props.report.pagination
    this.props.archiveReport(report_id, page)
  }

  cloneReport(report_id) {
    const {page} = this.props.report.pagination
    swal({
      text: "Name for cloned report instance",
      content: "input",
      buttons: {
        confirm: {
          text: "Clone",
          value: true,
          visible: true,
          className: "btn red darken-1 waves-effect waves-light",
          closeModal: true
        }
      }
    }).then(name => {
      if ( name && name.length > 0) {
        this.props.cloneReport(report_id, page, name)
      }
    })
  }

  fetchProject = (i) => {
    const report_id = this.props.report.id
    this.props.getProject(report_id, i)
  }

	render() {
		const { pagination, optimizations} = this.props;

		return (
			<React.Fragment>
				<table className="bordered striped highlight responsive-table project-list">
					<thead>
						<tr>
							<th>Report Instance Name</th>
							<th>Date Created</th>
							{
                // <th>User</th>
              }
							<th>Details</th>
							<th>Status</th>
						</tr>
					</thead>
					<tbody>
						{optimizations.map(function(optimization){
							const {id, name, created_at, entries, new_entries, removed, active, xml_url, xml_pending, lengthwarning } = optimization;
              const current = this.state.clickedId
              const disabled = ( xml_pending === true || entries === 0 )
              let class1, clip;

              let syncIcon, syncIconTitle;

              const lengthWarningIcon = ( lengthwarning !== true ) ? '' : <i className="material-icons c-red" title="This report instance has items with title-length longer than the allowed threshold">report_problem</i>

              class1 = ''
              if ( disabled ) {
                syncIconTitle = "Instance is archived"
                class1 = <i className="material-icons c-yellow" title={syncIconTitle}>access_time</i>;
              }  else if(active) {
                clip = (
                  <Clipboard data-clipboard-text={optimization.xml_url} className="clipboard">
                    <span>&nbsp;<span className="clip-blue">Copy url</span> |</span>
                  </Clipboard>
                );
							}

              let links
              if ( disabled ) {
                links = ''
              } else if (optimization.id !== current) {
                links = (
                  <div className="meta" onMouseLeave={(e) => {
                    this.resetCurrent()
                  }}>
                    <Link className="c-darkgrey" to={`/reports/${optimization.id}/entries`}>View</Link> |
                    {clip}
                    <Link
                      className="c-light-green"
                      to="#"
                      onClick={(e)=>{
                        e.preventDefault()
                        this.cloneReport(optimization.id)
                      }}
                      >&nbsp;Clone
                    </Link> |
                    <Link
                      className="red-text"
                      to="#"
                      onClick={(e)=>{
                        e.preventDefault()
                        this.setCurrent(optimization.id)
                      }}
                      >&nbsp;Trash</Link>

                  </div>
                )
              } else {
                links = (
                  <div className="meta">
                    <Link className="c-darkgrey" to="#" onClick={(e)=>{
                      e.preventDefault()
                      this.resetCurrent()
                    }}>Cancel</Link> |
                    <Link
                      className="red-text"
                      to="#"
                      onClick={(e)=>{
                        e.preventDefault()
                        this.archiveReport(optimization.id)
                      }}
                      >Are you sure?</Link>
                  </div>
                )
              }

              let link
              if ( disabled ) {
                link = <span>{name}</span>
              } else {
                link = <Link className="view" to={`/reports/${id}/entries`}>{name}</Link>
              }
							return (
                <tr key={id}>
									<td>
										{
                      //<Link className="view" to={`/reports/${id}/entries`}>{name}</Link>
                    }
                    { link }
                    <span className="shareable-url">{xml_url}</span>
                    { links }
									</td>
									<td>{new Date(created_at).toLocaleDateString()}, {new Date(created_at).toLocaleTimeString()}</td>
									{
                    // <td>user here</td>
                  }
                  <td>
										<small><p>{entries} Rows Published</p></small>
										<small><p>{new_entries} Rows Added</p></small>
										<small><p>{removed} Rows Deleted</p></small>
									</td>
									<td>{class1}{syncIcon}{lengthWarningIcon}</td>
								</tr>
							)
						}, this)}
					</tbody>
				</table>
        <Pagination pagination={pagination} fetchPage={this.fetchProject}/>
			</React.Fragment>
		)
	}
}

const ProjectOptimizations = connect(mapStateToProps, mapDispatchToProps)(ConnectedProjectOptimizations);

export default ProjectOptimizations;



// WEBPACK FOOTER //
// ./src/js/components/ProjectOptimizations.js